<template>
    <aside class="text-black p-3" style="width: 250px;">
        <div class="sidebar-header mb-4">
            <h3 class="fw-bold fs-5">Visennia</h3>
        </div>
        <nav>
            <ul class="nav flex-column">
                <!-- Lien Accueil -->
                <li class="nav-item">
                    <router-link to="/dashboard/espace" class="nav-link text-black d-flex align-items-center fs-6 fw-bold" active-class="bg-warning text-black">
                        <i class="bi bi-house-door me-2"></i>Accueil
                    </router-link>
                </li>
    
                <!-- Lien Articles -->
                <li class="nav-item">
                    <router-link to="/dashboard/add-article" class="nav-link text-black d-flex align-items-center fs-6 fw-bold" active-class="bg-warning text-black">
                        <i class="bi bi-file-earmark-text me-2"></i> Ajouter Articles
                    </router-link>
                </li>
    
                <!-- Lien Podcasts -->
                <li class="nav-item">
                    <router-link to="/dashboard/add-podcast" class="nav-link text-black d-flex align-items-center fs-6 fw-bold" active-class="bg-warning text-black">
                        <i class="bi bi-mic me-2"></i>Ajouter Podcast
                    </router-link>
                </li>
    
                <!-- Lien Commentaires -->
                <li class="nav-item">
                    <router-link to="/dashboard/manage-podcast" class="nav-link text-black d-flex align-items-center fs-6 fw-bold" active-class="bg-warning text-black">
                        <i class="bi bi-pencil me-2"></i>Editer Podcast
                    </router-link>
                </li>
    
                <!-- Lien Statistiques -->
                <li class="nav-item">
                    <router-link to="/dashboard/manage-article" class="nav-link text-black d-flex align-items-center fs-6 fw-bold" active-class="bg-warning text-black">
                        <i class="bi bi-pencil me-2"></i>Editer Article
                    </router-link>
                </li>
    
                <!-- Lien Profil -->
                <li class="nav-item">
                    <router-link to="/dashboard/manage-profil" class="nav-link text-black d-flex align-items-center fs-6 fw-bold" active-class="bg-warning text-black">
                        <i class="bi bi-person-circle me-2"></i>Profil
                    </router-link>
                </li>
    
                <!-- Lien Ajouter Blogueur -->
                <li class="nav-item">
                    <router-link to="/dashboard/add-blogger" class="nav-link text-black d-flex align-items-center fs-6 fw-bold" active-class="bg-warning text-black">
                        <i class="bi bi-person-plus me-2"></i>Ajouter Blogueur
                    </router-link>
                </li>

                <!-- Lien Déconnexion -->
                <li class="nav-item">
                    <button @click="logout" class="nav-link text-black d-flex align-items-center fs-6 fw-bold" style="border: none; background: none; cursor: pointer;">
                        <i class="bi bi-box-arrow-right me-2"></i>Déconnexion
                    </button>
                </li>
            </ul>
        </nav>
    </aside>
</template>

<script>
export default {
    methods: {
        logout() {
            sessionStorage.clear();
            this.$router.push('/login');
        }
    }
}
</script>
